<div style=" display: inline;block-size: 10%;">

    <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite " style="padding-right: 0px;padding: 15px 0px 10px 25px;">

        <div class="col-md-4 col-sm-6" style="display: inline-block;margin-left: 0px;
        padding-left: 5px;">

            <h2 class="ng-binding header" style="font-size: 28px !important;">
                Voucher Search
            </h2>
        </div>

        <div class="col-md-8 col-sm-6" style="display: inline-block; padding: 0px;text-align: right;">
            <span class="search">
                <span class="fa fa-search"></span>
                <input class="form-control brdrColor" ng-model="search.term" placeholder="Search" matInput
                    (keyup)="applyFilter($event)" #input
                    style="text-align: left; margin-right: 10px; display: inline-block; padding-left: 35px !important; border-radius: 25px !important; font-size: 13px; box-shadow: none; width: 30% !important; height: 35px !important;"
                    type="text">
            </span>

            <span (click)="refresh()" class="btn btn-green"
                style="cursor: pointer;line-height: 22px; padding: 5px 11px;" title="Refresh">
                <span>
                    <i aria-hidden="true" style="font-size: 14px;" class="fa fa-refresh"></i>
                </span>
            </span>

            <span (click)="exportToExcel()" class="btn btn-teal"
                style="margin-left: 10px; cursor: pointer;line-height: 22px; padding: 5px 11px;"
                title="Export to Excel">
                <span>
                    <i aria-hidden="true" style="font-size: 14px;" class="fa fa-file-excel-o"></i>
                </span>
            </span>

            <div style="display: inline-block; padding: 0px;" title="Back to account">
                <span class="btn-blue"
                    style="font-size: 13px; display: inline-block; padding: 5px 12px 6px; margin-left: 10px;"
                    (click)="backBtn()">
                    <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Back
                </span>
            </div>
        </div>
    </div>
</div>

<!-- filters -->
<div class="col-md-12 col-12 col-sm-12 pad0" style="padding: 10px 0px 10px 25px; padding-right: 0px;padding-top: 0px;font-size: 13px !important;">
    <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder"
        style="padding-top: 5px; padding-bottom: 0px; padding-right: 0px;padding-left: 0px;">
        <span (click)="typeFilter(2)" class="label orangeBadge fntSz {{filter == 2 ? 'activeOrange' : ''}}"
            style="cursor: pointer; margin-left: 0px;"><span>Last Month</span> </span>
        <span (click)="typeFilter(1)" class="label yellowBadge fntSz {{filter == 1 ? 'activeYellow' : ''}}"
            style="cursor: pointer; margin-left: 10px;"><span>This Month</span></span>
        <span (click)="typeFilter(3)" class="label greenBadge  fntSz {{filter == 3 ? 'activeGreen' : ''}}"
            style="cursor: pointer; margin-left: 10px;"><span>Others</span> </span>

        <div style="display: inline-block;margin-left: 10px;" *ngIf="filter == 3">
            <label
                style="display: inline-block; margin-bottom:0px; font-weight: normal;"
                for="sel1">Month : </label>
        </div>
        <div style="display: inline-block;margin-left: 10px;" *ngIf="filter == 3">
            <select class="form-control" style="box-shadow: none;" [(ngModel)]="view.month" tabindex="1"
                (change)="getmonthyear()">
                <option [value]="i.id" *ngFor="let i of months;">{{i.display}}</option>
            </select>
        </div>

    </div>
</div>

<div class="col-md-12 col-12 col-sm-12 pad0" style="padding: 0px 0px 10px 25px;" #epltable
    *ngIf="dataSource.data.length >0">
    <table mat-table [dataSource]="dataSource" matSort style="width: 100%;">
        <ng-container matColumnDef="VoucherNo">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label style="cursor: pointer;">Voucher No</label>
            </th>
            <td mat-cell *matCellDef="let item" style="text-align: left; width: 120px !important;cursor: pointer; ">
                {{item.VoucherNo}}
            </td>
        </ng-container>

        <!-- Type -->
        <ng-container matColumnDef="Type">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label style="cursor: pointer;">Type</label>
            </th>
            <td mat-cell *matCellDef="let item" style="text-align: left; width: 200px !important; cursor: pointer; ">
                {{item.voucherType}}
            </td>
        </ng-container>

        <!-- Date -->
        <ng-container matColumnDef="Date">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label style="cursor: pointer;">Date</label>
            </th>
            <td mat-cell *matCellDef="let item" style="text-align: left; width: 100px !important;cursor: pointer; ">
                {{item.EffectiveDate | todayTommorow}}
            </td>
        </ng-container>

        <!-- DbLedger -->
        <ng-container matColumnDef="DbLedger">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label style="cursor: pointer;">Db Ledger</label>
            </th>
            <td mat-cell *matCellDef="let item" style="text-align: left; width: 150px !important;cursor: pointer; ">
                {{item.MainDbLedger ? item.MainDbLedger : '-'}}
            </td>
        </ng-container>

        <!-- CrLedger -->
        <ng-container matColumnDef="CrLedger">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                <label style="cursor: pointer;">Cr Ledger</label>
            </th>
            <td mat-cell *matCellDef="let item" style="text-align: left; width: 150px !important;cursor: pointer; ">
                {{item.MainCrLedger ? item.MainCrLedger : '-'}}
            </td>
        </ng-container>

        <!-- Debit -->
        <ng-container matColumnDef="Debit">
            <th class="header header-Table" style="cursor: pointer; text-align: right;padding-left: 25px;"
                mat-header-cell *matHeaderCellDef mat-sort-header>
                <label style="cursor: pointer;text-align: right;margin-left: 23px !important;">Debit</label>
            </th>
            <td mat-cell *matCellDef="let item"
                style="text-align: right; width: 100px !important;cursor: pointer;padding-right: 10px; ">
                {{item.DbAmtSum == null ? '-' : item.DbAmtSum | lacFormat}}
            </td>
        </ng-container>
        
        <!-- Credit -->
        <ng-container matColumnDef="Credit">
            <th class="header header-Table" style="cursor: pointer;padding-left: 48px !important;" mat-header-cell
                *matHeaderCellDef mat-sort-header>
                <label style="cursor: pointer;">Credit</label>
            </th>
            <td mat-cell *matCellDef="let item"
                style="text-align: right; width: 100px !important;cursor: pointer;padding-right: 10px; ">
                {{item.CrAmtSum == null ? '-' : item.CrAmtSum | lacFormat}}
            </td>
        </ng-container>

        <!-- Notes -->
        <ng-container matColumnDef="Notes">
            <th class="header header-Table" style="cursor: pointer;padding-left: 12px;" mat-header-cell
                *matHeaderCellDef mat-sort-header>
                <label style="cursor: pointer;display:none">Notes</label>
            </th>
            <td mat-cell *matCellDef="let item">
                <div>
                    <i *ngIf="item.Notes" style="color:#E1A730; margin: 5px; text-align: left; width: 150px !important;cursor: pointer;cursor: pointer;padding-left: 18px" class="fa fa-sticky-note"
                        title="{{item.Notes ? item.Notes : ''}}"></i> 
                </div>
            </td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="Actions">
            <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef>
                <label style="cursor: pointer;">Actions</label>
            </th>
            <td mat-cell *matCellDef="let item">
                <div (click)="printVoucher(item.VoucherID);$event.stopPropagation()" title="Print"
                    style="font-size: 17px; color: #E88421 ; cursor: pointer; ">
                    <i aria-hidden="true" class="zmdi zmdi-print"></i>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let item; columns: displayedColumns" (click)="editVoucher(mymodal, item)"></tr>
    </table>
    <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[5,10, 20]" showFirstLastButtons>
    </mat-paginator>
</div>

<div class="col-md-12 col-sm-12 col-xs-12" *ngIf="dataSource.data.length == 0"
    style="padding: 10px 0px 10px 25px;margin-top: 20px;margin-left: 5px;margin-bottom: 20px;">
    No records found.
</div>

<!-- <div style="margin-left: 5px;padding: 10px 0px 10px 25px;">This feature is under development.</div> -->

<!--Voucher Entry/Edit Modal-->
<ng-template #mymodal let-modal>
    <div class="modal-body" style="padding: 0px;">
        <app-voucher-entry (oncloseVchrModal)="closeModal($event)"></app-voucher-entry>
    </div>
</ng-template>